import React, { useState, useEffect } from 'react'
import { GridWrapper, ItemsWrapper } from './style'
import TripItem from './TripItem'
import { GridTitle, GridSubtitle, ShowMoreCta } from './style'
import { getTranslations } from '../../../../utils'

const TripsGrid = ({
  id,
  items,
  title,
  isLessThanLaptop,
  router,
  language,
  random_match,
  showRelevancyInfo,
  itemsPerRow,
  itemsPerPage,
  isChatMode,
}) => {
  const [currentIsLessThanLaptop, setIsCurrentIsLessThanLaptop] =
    useState(false)
  const [itemsToShow, setItemsToShow] = useState(0)
  const [gridId, setGridId] = useState(null)

  useEffect(() => {
    if (isLessThanLaptop) setIsCurrentIsLessThanLaptop(isLessThanLaptop)
  }, [isLessThanLaptop])

  useEffect(() => {
    if (id !== gridId) {
      setGridId(id)
      setItemsToShow(itemsPerPage)
    }
  }, [id])

  if (!items?.length) return null

  const getItems = () => {
    const slicedItemsToShow = items.slice(0, itemsToShow)

    let itemsToReturn = slicedItemsToShow?.map((item, i) => {
      return (
        <TripItem
          key={item.id || item.url + item?.name}
          index={i}
          isLessThanLaptop={currentIsLessThanLaptop}
          router={router}
          item={item}
          language={language}
          showRelevancyInfo={showRelevancyInfo}
          randomMatch={random_match}
          itemsPerRow={itemsPerRow}
        />
      )
    })

    return itemsToReturn
  }

  if (getItems().length) {
    return (
      <GridWrapper id='grid-wrapper-trip'>
        <GridTitle $padding={'0px 15px 0px 0px'} isChatMode={isChatMode}>
          {title}
        </GridTitle>
        <ItemsWrapper id='grid-trip-items-wrapper'>{getItems()}</ItemsWrapper>
        {itemsToShow < items.length ? (
          <ShowMoreCta
            onClick={() => {
              setItemsToShow(itemsToShow + itemsPerPage)
            }}
          >
            {getTranslations('show_more')}
          </ShowMoreCta>
        ) : null}
      </GridWrapper>
    )
  } else return null
}

export default TripsGrid
